import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { batch, useDispatch, useSelector } from "react-redux";
import { ShimmerContentBlock } from "react-shimmer-effects";

import {
  generateCifForOffer,
  getDocumentsCi,
  getOfferDetails,
} from "@/api/placeOffer";
import CifDetails from "./CifDetails";
import useAuth from "../common/header/useAuth";
import OfferWizard from "./offerWizard";

import ProfileVerification from "./profileVerification";
import "./index.css";
import BidFooter from "../bid/BidFooter";
import { checkLoginStatus } from "@/api/myProfile";
import { logOut, userData } from "@/redux/user/userSlice";
import MetaComponent from "../common/MetaComponent";
import { toast } from "react-toastify";
import { deleteCookie } from "@/utils/cookies";
import LoginModal from "../common/user-credentials/LoginModal";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import { updateSaveProperty } from "@/redux/PDP/pdpSlice";
import { getWebCMS } from "@/api/PDP";

const Offer = () => {
  const [currentCifStep, setCurrentCifStep] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const user = useSelector((state) => state.user.user);
  const { userName } = useAuth();
  const navigate = useNavigate();
  const [offerDetails, setOfferDetails] = useState({});
  const [propertyId, setPropertyId] = useState("");
  const [cifId, setCifId] = useState("");
  const [cifCompleted, setCifCompleted] = useState(false);
  const [idologyVerified, setIdologyVerified] = useState(
    user?.user?.idologyVerified || true
  );
  const [isFromCif, setIsFromCif] = useState(false);
  const [cifDataDocuments, setCifDataDocuments] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const dropdownRef = useRef(null);
  const [cifDataLoaded, setCifDataLoaded] = useState(false); 
  const globalPopup = useSelector((state) => state.login);
  const pdpInitData = useSelector((state) => state.pdp?.offerData);
  const [userId,setUserId] = useState(user?.realbidUserId)
  const [webCMS, setWebCMS] = useState(null);

const dispatch = useDispatch();

  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };
   const { offerPage, listingId } = offerDetails || {};
  const { propertyDetails, isAgent } = offerPage || {};

  const fullAddress = `${propertyDetails?.address?.streetNumber} ${propertyDetails?.address?.streetName} | Hubzu`
  const metaData = {
  title: fullAddress || "Homes For Sale | Hubzu",
  }   

  const cifStatusForOffer = async () => {
    try {
      setLoading(true);
      const data = await generateCifForOffer({
        listingId: pdpInitData?.listingId,
        userId:  userId || user?.realbidUserId,
      });
      setCurrentCifStep(data.currentCifStep || "CI_NOT");
      setCifId(data.cifId);
      if(data?.cifId){
        getCifDocument(data?.cifId)
      }else{
        setCifDataLoaded(true)
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchDetails = async () => {
    try {
      setLoading(true);
      const offerBody = {
        listingId:  pdpInitData?.listingId,
        offerAmount: pdpInitData?.offerAmount,
        offerType: pdpInitData?.offerType,
      };
      const data = await getOfferDetails(offerBody);
      if (data?.ERROR === "SESSION_INVALID") {
        toast.error("current session not valid, Please login again");
               batch(() => {
                 dispatch(setLoginModal(true));
                 dispatch(setLoginTab("loginTab"));
                 dispatch(setLoginCallLocation("Popup"));
               });
      }else{
        setOfferDetails(data);
        setPropertyId(data?.offerPage?.propertyId);
        // setIdologyVerified(user?.user?.idologyVerified)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  
  // useEffect(()=>{
  //   if(location.state===null){
  //     navigate('/register-sign-in')
      
  //   }    
  // },[location])

const getLoginStatus  =async()=>{
  try {
    const data = await checkLoginStatus(); 
    //  await getExperiments("onLoad");
     if (data?.isValidSession === "N") {
            dispatch(logOut({ isUserLoggedIn: false }));
            dispatch(updateSaveProperty("N"));
            deleteCookie("isLoggedIn");
          } else {
            setUserId(data?.realbidUserId)
            dispatch(
              userData({
                userFirstName: data.userFirstName,
                userType: data.userType,
                isUserLoggedIn: true,
                user: data,
              })
            );
            setIdologyVerified(data?.idologyVerified)
          }
  } catch (error) {
    console.log(error);
    
  }
}
  useEffect(()=>{
    const fetchWebCMS = async () => {
      try {
        const response = await getWebCMS("pages/offerWizard");
        setWebCMS(response?.results);
      } catch (error) {
        console.error("Failed to fetch CMS data:", error);
      }
    };
    
    fetchWebCMS();
    getLoginStatus();
  
  },[])

  useEffect(() => {
    if(userId){
      fetchDetails();
      cifStatusForOffer();
    }
  }, [cifCompleted,idologyVerified,userId]);



  useEffect(() => {
    if (cifId && currentCifStep !== "CI_UPFRONT_READY") {
      getCifDocument(cifId);
    }
  }, [cifId]);
  

  const getCifDocument = async (cifId) => {
    try {
      const data = await getDocumentsCi({ cifId });
      setCifDataDocuments(data.data || {});
    } catch (error) {
      console.error(error);
       setCifDataDocuments({});
    }
    finally{
      setCifDataLoaded(true)
    }
  };
  
const processFaqData = (faqsData) => {
  if (!faqsData) return [];
  
  return Object.values(faqsData)
    .filter(item => item.question && item.answer)
    .map(item => ({
      question: item.question,
      answer: item.answer
    }));
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (loading)
    return (
      <div className="offer-loader p-5 mb-5">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      </div>
    );
  if (!pdpInitData?.listingId) {
    return (
      <div className="offer-loader p-5 mb-5">
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      </div>
    );
  }

  return (
    <>
     <MetaComponent meta={metaData} />
       {globalPopup?.loginModal && <LoginModal popUpMsg={true}/>}
      <header className="container-fluid prpl30 offer-header">
        <img
          className="logo2 contain cursor-pointer"
          src="/assets/images/hubzu-logo.png"
          alt="hubzu-logo"
          onClick={() => navigate("/")}
        />

        <div className="right-side">
          <span
            className="cursor-pointer offer-faq-right"
            ref={dropdownRef}
            onClick={toggleDropdown}
          >
            Offer FAQs
          </span>
          <span className="username-right"> {userName}</span>
          {showDropdown && (
            <div className="offer-faq-dropdown" ref={dropdownRef}>
              {processFaqData(webCMS?.[0]?.faqsData).map((faq, index) => (
                <div key={index} className="offer-faq-item">
                  <div
                    className="offer-faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    <strong>{faq.question}</strong>
                    <span className="offer-arrow">
                      {activeIndex === index ? "▴" : "▾"}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <div className="offer-faq-answer">
                      {" "}
                      {faq.answer.split(/<br\s*\/?>/).map((line, i) => (
                        <p className="offer-faq-answer" key={i}>
                          {line}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </header>

      <div className="offer">
        <section className="offer-body-main container">
          {!idologyVerified ? (
            <ProfileVerification
              offerDetails={offerDetails}
              setIdologyVerified={setIdologyVerified}
            />
          ) : (
            <>
              {currentCifStep === "CI_UPFRONT_READY" ? (
                <CifDetails
                  offerDetails={offerDetails}
                  cifId={cifId}
                  setCifCompleted={setCifCompleted}
                  setIsFromCif={setIsFromCif}
                />
              ) : 
              <>{cifDataLoaded && (
  <OfferWizard
    offerDetails={offerDetails}
    userId={userId}
    cifId={cifId}
    cifDataDocuments={cifDataDocuments}
    userRole={offerDetails?.offerPage?.isAgent?"Agent":"Buyer"}
    offerType={pdpInitData?.offerType}
  />
)}
</>
              }
            </>
          )}
        </section>
        <BidFooter />
      </div>
    </>
  );
};

export default Offer;
